import IngameDlpTopChartContext from '@/pages/dashboard/pages/monetization/ingameRevenue/components/IngameDlpTopChartContext';
import SalesBreakdownTab from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownTab';
import React, { useMemo } from 'react';
import './index.scss';
const IngameDlpTopChartContextTransfer = (props: any) => {
  const { tabConfigMap, data, extMetricMap, ...restProps } = props;
  const { data: propsData, breakDownData, metric, segmentVal } = data;
  const { by_tab: byTab, by_top10_metric: byTop10Metric } = propsData || {};
  const { data: apiData } = breakDownData || {};

  // 格式化数据
  const transformDataList = (dataList: any[]) => {
    const result: Record<string, any> = {};
    dataList?.forEach((item: Record<string, any>) => {
      Object.entries(item).forEach(([key, value]) => {
        result[key] = Array.isArray(value) ? value : {};
      });
    });
    return result;
  };

  const { radioConfig, newConfig, segmentConfig } = useMemo(() => {
    // 顶部口径切换
    const config = tabConfigMap?.[byTab];
    const {
      radioConfig,
      segmentConfig,
      chartConfig,
      downloadConfig,
      ...restConfig
    } = config || {};
    // 指标切换的时候
    if (chartConfig) {
      const chartOptions = chartConfig[byTop10Metric] || [];
      restConfig.chart = [...(restConfig.chart || []), ...chartOptions];
    }

    if (downloadConfig) {
      const downloadOptions = downloadConfig[byTop10Metric] || [];
      restConfig.download = [
        ...(restConfig.download || []),
        ...downloadOptions,
      ];
    }

    restConfig.defaultSortMetric = restConfig.sortMetric;

    return {
      newConfig: restConfig,
      radioConfig,
      segmentConfig,
    };
  }, [tabConfigMap, byTab, byTop10Metric]);

  const newBreakDwonData = useMemo(() => {
    if (!apiData) return breakDownData;
    // metric 有且只能有两个
    const dataList = metric?.map((item) => ({
      [item]: apiData?.map(
        (meitricsItem: {
          metrics: { [x: string]: any; };
          name: any;
          full_name: any;
          value: string;
        }) => {
          const metricDataItem = meitricsItem?.metrics?.[item];
          const metricContrastDataItem =
            meitricsItem?.metrics?.[extMetricMap?.[item]];
          // 兼容FTC组件进行数据处理
          return {
            ...(metricDataItem || {}),
            name: meitricsItem?.name || '',
            full_name: meitricsItem?.full_name || '',
            // 对比的值和百分比
            value_ext1: metricContrastDataItem?.value,
            share_off_all_ext1: metricContrastDataItem?.share_off_all,
          };
        },
      ),
    }));
    const dataObj = transformDataList(dataList);
    return {
      ...breakDownData,
      data: { ...(dataObj || {}) },
      by_type: segmentVal,
    };
  }, [breakDownData, extMetricMap, metric, segmentVal]);

  return (
    <div className="dbd-ingame-dlp-top-chart-context-transfer">
      <SalesBreakdownTab
        radioConfig={radioConfig}
        segmentConfig={segmentConfig}
        changeData={props?.changeData}
        // 传入 MetricInfo 共享 data，保证 net/gross 切 tab remount 后
        // Product / Product Category 能按 by_type 正确回显，避免误触不刷新
        data={propsData}
      ></SalesBreakdownTab>
      <IngameDlpTopChartContext
        key={byTop10Metric}
        config={newConfig}
        // 占位div
        secTitle={radioConfig || segmentConfig ? <div className='dbd-ingame-dlp-top-context-empty'>&nbsp;</div> : null}
        data={{ ...data, breakDownData: newBreakDwonData }}
        extMetricMap={extMetricMap}
        {...restProps}
      ></IngameDlpTopChartContext>
    </div >
  );
};

export default IngameDlpTopChartContextTransfer;
